import React, { useState } from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Input, InputPassword } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Switch } from '@/components/ui/switch';
import { Textarea } from '@/components/ui/textarea';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { ComboboxSingle } from '@/components/ui/combobox-single';
import { ComboboxMultiple } from '@/components/ui/combobox-multiple';
import { Filter, FilterContent, FilterRow, FilterTitle, FilterHat, FilterInput, FilterRadioGroup, FilterAlert } from '@/components/custom/filter';
import { FiAlertTriangle, FiSearch, FiUser } from 'react-icons/fi';

const SUBJECT_OPTIONS = [
  { value: 'mat', label: 'Matematica' },
  { value: 'por', label: 'Portugues' },
  { value: 'his', label: 'Historia' },
  { value: 'geo', label: 'Geografia' },
  { value: 'cie', label: 'Ciencias' },
  { value: 'fis', label: 'Fisica' },
  { value: 'qui', label: 'Quimica' },
  { value: 'bio', label: 'Biologia' }
];

export function FormsSection() {
  const [inputValue, setInputValue] = useState('');
  const [radioValue, setRadioValue] = useState('option-1');
  const [filterRadio, setFilterRadio] = useState('opt-a');
  const [switchOn, setSwitchOn] = useState(true);
  const [comboSingle, setComboSingle] = useState(null);
  const [comboMulti, setComboMulti] = useState([]);

  return (
    <ShowcaseSection
      id="forms"
      title="Forms & Inputs"
      description="Inputs, switches, checkboxes, textarea, radio, combobox e familia Filter"
    >
      <ShowcaseItem
        label="Input"
        description="Campo de texto basico"
      >
        <div className="grid max-w-lg gap-4">
          <div>
            <Label className="mb-1">Nome completo</Label>
            <Input
              placeholder="Digite seu nome..."
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
            />
          </div>
          <div>
            <Label className="mb-1">Senha</Label>
            <InputPassword placeholder="Digite sua senha" />
          </div>
          <div>
            <Label className="mb-1">Desabilitado</Label>
            <Input
              placeholder="Campo desabilitado"
              disabled
            />
          </div>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Textarea"
        description="Area de texto multilinha"
      >
        <div className="max-w-lg">
          <Label className="mb-1">Descricao</Label>
          <Textarea
            placeholder="Descreva detalhadamente..."
            rows={4}
          />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Checkbox"
        description="Selecao multipla"
      >
        <div className="flex flex-col gap-3">
          <label className="flex items-center gap-2">
            <Checkbox /> Opcao 1
          </label>
          <label className="flex items-center gap-2">
            <Checkbox defaultChecked /> Opcao 2 (marcada)
          </label>
          <label className="flex items-center gap-2 opacity-50">
            <Checkbox disabled /> Opcao 3 (desabilitada)
          </label>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="RadioGroup"
        description="Grupo de selecao unica"
      >
        <RadioGroup
          value={radioValue}
          onValueChange={setRadioValue}
          className="flex flex-col gap-3"
        >
          {['option-1', 'option-2', 'option-3'].map(v => (
            <label
              key={v}
              className="flex cursor-pointer items-center gap-2"
            >
              <RadioGroupItem value={v} /> {v}
            </label>
          ))}
        </RadioGroup>
        <p className="mt-2 text-xs text-neutral-dark">
          Selecionado: <code className="text-primary">{radioValue}</code>
        </p>
      </ShowcaseItem>

      <ShowcaseItem
        label="Switch"
        description="Toggle on/off (uso real: 'Publicar' no CourseCardAdmin)"
      >
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <Switch
              checked={switchOn}
              onCheckedChange={setSwitchOn}
            />
            <Label>Publicar</Label>
          </div>
          <Switch defaultChecked />
          <Switch />
          <Switch disabled />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="ComboboxSingle"
        description="Select com busca — 1 opcao"
      >
        <div className="max-w-md">
          <Label className="mb-1">Materia</Label>
          <ComboboxSingle
            options={SUBJECT_OPTIONS}
            value={comboSingle}
            onValueChange={setComboSingle}
            placeholder="Selecione uma materia"
          />
          <p className="mt-2 text-xs text-neutral-dark">
            Selecionado: <code className="text-primary">{comboSingle || 'nenhum'}</code>
          </p>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="ComboboxMultiple"
        description="Multi-select com chips removiveis"
      >
        <div className="max-w-md">
          <Label className="mb-1">Materias</Label>
          <ComboboxMultiple
            options={SUBJECT_OPTIONS}
            value={comboMulti}
            onValueChange={setComboMulti}
            placeholder="Selecione varias materias"
          />
          <p className="mt-2 text-xs text-neutral-dark">
            Selecionados: <code className="text-primary">{comboMulti.length === 0 ? 'nenhum' : comboMulti.join(', ')}</code>
          </p>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Filter"
        description="Container de filtros com hat, titulo e linhas"
      >
        <Filter variant="plain">
          <FilterContent>
            <FilterRow>
              <FilterHat>Categoria</FilterHat>
              <FilterTitle>Selecione</FilterTitle>
            </FilterRow>
          </FilterContent>
        </Filter>
      </ShowcaseItem>

      <ShowcaseItem
        label="FilterInput"
        description="Input de filtro com label e icone"
      >
        <FilterInput
          label="Buscar"
          placeholder="Nome ou email"
          startIcon={FiSearch}
        />
        <div className="mt-3">
          <FilterInput
            label="Pesquisa"
            type="search"
            placeholder="Digite para buscar"
          />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="FilterRadioGroup"
        description="Grupo de radios em filtro (versao com FormRadio)"
      >
        <FilterRadioGroup
          value={filterRadio}
          onValueChange={setFilterRadio}
          radios={[
            { id: 'fa', value: 'opt-a', label: 'Opcao A' },
            { id: 'fb', value: 'opt-b', label: 'Opcao B' },
            { id: 'fc', value: 'opt-c', label: 'Opcao C' }
          ]}
        />
        <p className="mt-2 text-xs text-neutral-dark">
          Selecionado: <code className="text-primary">{filterRadio}</code>
        </p>
      </ShowcaseItem>

      <ShowcaseItem
        label="FilterAlert"
        description="Mensagem de alerta em filtros"
      >
        <FilterAlert>
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-warning text-white">
            <FiAlertTriangle size={16} />
          </span>
          Nenhum participante encontrado com esses filtros.
        </FilterAlert>
        <div className="mt-3">
          <FilterAlert>
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-danger text-white">
              <FiUser size={16} />
            </span>
            Selecione ao menos uma turma para visualizar.
          </FilterAlert>
        </div>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
